import styled from "@emotion/styled";

export interface IPageProps extends React.HTMLAttributes<HTMLDivElement> {
    scrollable?: boolean;
}

export const Page = styled.div<IPageProps>`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: ${props => (props.scrollable ? "auto" : "hidden")};
`;
